export function replaceClass(
    DivID: string,
    OneClass: string,
    TwoClass: string
) {
    document.getElementById(DivID)?.classList.replace(OneClass, TwoClass);
}
export function AddRemoveClass(DivID: string, ClassName: string) {
    document.getElementById(DivID)?.classList.add(ClassName);
}
export function toogleClasses(
    DivID: string,
    OneClass: string,
    TwoClass: string
) {
    document.getElementById(DivID)?.classList.toggle(OneClass);
    document.getElementById(DivID)?.classList.toggle(TwoClass);
}

export function setClassBgStatus(
    status: string,
    OKStatus: string,
    NOKStatus: string
) {
    if (status === OKStatus) return "bg-light-success  border-success";
    else if (status === NOKStatus) return "bg-light-danger  border-danger";
    else return "bg-secondary  border-secondary";
}
export function setClassLabelStatus(
    status: string,
    OKStatus: string,
    NOKStatus: string
) {
    if (status === OKStatus) return "text-success";
    else if (status === NOKStatus) return "text-danger";
}
